import {Component} from 'react'
import {logTime} from '../../utils/logger'
import {AppLoadedProps} from './'

export class AppLoaded extends Component<AppLoadedProps> {
  componentDidMount() {
    logTime('APP_LOAD')
    this.props.appLoaded()
    this.props.appLoaded643()
  }

  render() {
    return null
  }
}
